export const HOME = '/';
export const AUTH = '/auth';
export const USER = '/user';
export const POST = '/post';
export const LOGIN = `${AUTH}/login`;
export const REGISTER = `${AUTH}/register`;
export const RESET_PASSWORD = `${AUTH}/resetpassword/:resettoken`;

// Private routes
export const DASHBOARD = '/dashboard';
export const MANAGE_ACOUNT = `${DASHBOARD}/manage-account`;
export const MY_PROFILE = `${DASHBOARD}/profile`;
export const MY_FRIENDS = `${DASHBOARD}/friends`;
export const MY_COINS = `${DASHBOARD}/coins`;
export const USER_PROFILE = `${DASHBOARD}/profile/:username`;
export const USER_POSTS = `${USER_PROFILE}/posts`;
export const LIVE_STREAM = `${DASHBOARD}/live-stream`;
export const MY_POSTS = `${DASHBOARD}/posts`;
export const CREATE_POST = `${DASHBOARD}/posts/create-post`;
export const EDIT_POST = `${DASHBOARD}/posts/:slug/edit`;
export const VIEW_POST = `${DASHBOARD}/posts/:slug`;
export const MESSAGE_REQUESTS = `${DASHBOARD}/message-requests`;
export const LEADERBOARD = `${DASHBOARD}/leaderboard`;
export const CHAT = `${DASHBOARD}/chat`;
export const CREATE_STREAM = `${DASHBOARD}/streams/create-stream`;
export const STREAM_INSTRUCTION = `${DASHBOARD}/streams/instructions`;
export const WATCH_USER_STREAM = `${DASHBOARD}/user/streams/watch/:id`;
export const WATCH_GAMER_STREAM = `${DASHBOARD}/gamer/streams/watch/:id`;
